import type { ToggleButtonGroupProps as MUIToggleButtonGroupProps } from '@mui/material';
import { ToggleButton, ToggleButtonGroup as MUIToggleButtonGroup } from '@mui/material';
import React from 'react';

type ToggleButtonGroupProps = Omit<MUIToggleButtonGroupProps, 'value' | 'onChange'> & {
  activeView: string;
  // `title` is a node, not a string: the invoice page's subtab toggles carry a
  // count chip beside their label.
  readonly viewList: { value: string; title: React.ReactNode }[];
  handleChange: (_: React.MouseEvent<HTMLElement>, newValue: string) => void;
};

function ToggleButtonGroup({
  activeView,
  handleChange,
  viewList,
  ...props
}: ToggleButtonGroupProps) {
  return (
    <MUIToggleButtonGroup
      color="primary"
      exclusive
      aria-label="portfolio-view"
      {...props}
      value={activeView}
      onChange={handleChange}
    >
      {viewList.map((view) => (
        <ToggleButton key={view.value} value={view.value}>
          {view.title}
        </ToggleButton>
      ))}
    </MUIToggleButtonGroup>
  );
}

export default ToggleButtonGroup;
